import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-en',
  templateUrl: './footer-en.component.html',
  styleUrls: ['./footer-en.component.scss']
})
export class FooterEnComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
